<template>
    <div style="max-width: 100%;">
        <div class="zz_blocks" style="max-width: 100%;" v-for="b in blocks" :style="{'marginTop':getAbstand(b)+'px'}" :key="b">

            <SimpleText v-if="b.acf_fc_layout==='text_onecol'" :b="b"></SimpleText>
            <Parallax v-if="b.acf_fc_layout==='parallax'" :b="b"></Parallax>
            <Fullimage v-if="b.acf_fc_layout==='vollbild'" :b="b"></Fullimage>
            <Fullvideo v-if="b.acf_fc_layout==='video'" :b="b" :options="getOptions(b)"></Fullvideo>
            <Buttonvideo v-if="b.acf_fc_layout==='video_button'" :b="b" :options="getOptions(b)"></Buttonvideo>
            <Slider v-if="b.acf_fc_layout==='slider'" :b="b"></Slider>
            <Linie v-if="b.acf_fc_layout==='line'" :b="b"></Linie>
            <Akkordeon v-if="b.acf_fc_layout==='akkordeon'" :b="b"></Akkordeon>
          <div class="widewidth">

            <div class="text row  twocols justify-content-between" v-if="b.acf_fc_layout==='zwei_spalten'"
                 :class="{mobileswitch:b.mobileswitch}">
                <div class="col-60 col-md-29 left">
                    <TwoCols v-for="(b,index) in b.links" :b="b" :key="index">
                    </TwoCols>
                </div>
                <div class="col-60 col-md-29 right">
                    <TwoCols v-for="(b,index) in b.rechts" :b="b" :key="index">
                    </TwoCols>
                </div>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
    import SimpleText from '@/components/Blocks/Text.vue'
    import Parallax from '@/components/Blocks/Parallax.vue'
    import Fullimage from '@/components/Blocks/Fullimage.vue'
    import Fullvideo from '@/components/Blocks/Fullvideo.vue'
    import Buttonvideo from '@/components/Blocks/Buttonvideo.vue'
    import Slider from '@/components/Blocks/Slider.vue'
    import Linie from '@/components/Blocks/Line.vue'
    import TwoCols from '@/components/Blocks/TwoCols.vue'
    import Akkordeon from '@/components/Blocks/Akkordeon.vue'

    export default {
        name: "Blocks",
        props: ['blocks'],
        components: {SimpleText, Parallax, Slider, TwoCols, Fullimage, Fullvideo, Linie, Akkordeon, Buttonvideo},
        watch: {
            // b() {
            //     if(b.acf_fc_layout==='video') {
            //         this.getOptions(b)
            //     }
            // }
        },
        methods: {
            getOptions(b) {
                return {
                    autoplay: true,
                    controls: false,
                    loop: true,
                    height: 'auto',
                    poster: require('@/assets/Startbild-02.png'),
                    sources: [
                        {
                            src:
                            b.video.url,
                            type: "video/mp4"
                        }
                    ]
                }
            },
            getAbstand(b) {

                if (b.abstand_oben) {

                    return b.abstand_oben
                } else return 150;
            }
        }
    }
</script>
<style lang="scss">
    .zz_blocks {
        display: flex;
        margin-top: 150px;

        &:last-child {
            margin-bottom: 0;
        }

        @include mobile {
            margin: 50px 0!important;
        }
        flex-direction: column;
        align-items: center;

        div {
          @include mobile {

            padding: 0 10px;
          }
            &.smallwidth {
                max-width: 100%;

                width: 700px;
            }

            &.normalwidth {
                max-width: 100%;

                width: 1080px;
            }

            &.widewidth {
                max-width: 100%;

                width: 1280px;
            }
        }
    }

    .blockcontent {
        h1, h2 {
            color: $zzgray;
            border-bottom: none;
            font-weight: 300;
        }

        font-family: $sans;

        ul {
            li {
                list-style: none;

                h2 {
                    list-style: square;
                    display: list-item;
                    line-height: 110%;

                    &::marker {
                        color: $zzcolor;
                        font-size: 42px;
                    }
                }

            }
        }
    }

    .twocols {
        &.mobileswitch {
            @include mobile {
                .left {
                    order: 2;
                }
                .right {
                    order: 1;
                }
            }
        }
    }
</style>